module.exports = __webpack_public_path__ + "static/media/EELR.79da27a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EELR.jpg
// module id = 1734
// module chunks = 1